// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Lk-z","tupacHeader":"Mk-z","tupacHeader2":"Nk-z","tupacMenu":"Ok-z","tupacMenu2":"Pk-z","tupacMain":"Qk-z","tupacMain2":"Rk-z"};